import type { ComponentProps } from "react";
import { CaixasManualTransactionModal } from "@/components/caixas/CaixasManualTransactionModal";
import type { Supplier } from "@/features/supplier/types";

interface SupplierBoxTransactionModalProps {
  supplier: Pick<Supplier, "id" | "name" | "box_balance">;
  onClose: () => void;
  mutationOverride?: ComponentProps<
    typeof CaixasManualTransactionModal
  >["mutationOverride"];
}

export function SupplierBoxTransactionModal({
  supplier,
  onClose,
  mutationOverride,
}: SupplierBoxTransactionModalProps) {
  return (
    <CaixasManualTransactionModal
      supplier={supplier}
      onClose={onClose}
      mutationOverride={mutationOverride}
    />
  );
}
